var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flow-img-step",class:("step-active" + _vm.stepNum)},[_c('img',{attrs:{"src":require('@/assets/flow_step_img.png'),"alt":"参赛流程"}}),_c('span',{staticClass:"step-line"})])}
var staticRenderFns = []

export { render, staticRenderFns }